var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8903 12.9072L10.5817 9.59863C10.4997 9.54395 10.4176 9.48926 10.3356 9.48926H9.98014C10.8278 8.50488 11.3747 7.19238 11.3747 5.77051C11.3747 2.65332 8.80436 0.0830078 5.68717 0.0830078C2.54264 0.0830078 -0.000326157 2.65332 -0.000326157 5.77051C-0.000326157 8.91504 2.54264 11.458 5.68717 11.458C7.10905 11.458 8.39421 10.9385 9.40592 10.0908V10.4463C9.40592 10.5283 9.43327 10.6104 9.48796 10.6924L12.7965 14.001C12.9333 14.1377 13.152 14.1377 13.2614 14.001L13.8903 13.3721C14.027 13.2627 14.027 13.0439 13.8903 12.9072ZM5.68717 10.1455C3.25358 10.1455 1.31217 8.2041 1.31217 5.77051C1.31217 3.36426 3.25358 1.39551 5.68717 1.39551C8.09342 1.39551 10.0622 3.36426 10.0622 5.77051C10.0622 8.2041 8.09342 10.1455 5.68717 10.1455Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.74900f1b.svg";
export { ForwardRef as ReactComponent };